<template>
  <v-dialog eager v-model="dialog" max-width="330">
    <v-card>
      <v-card-title class="primary white--text"
        >Link per pagamento
        <v-spacer></v-spacer>
        <v-btn depressed icon @click="dismiss()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>
      <div class="px-5 pt-5">
        <div class="cc d-flex justify-center mt-2">
          <img :src="firebase_host + '/static/img/cc-1.png'" />
          <img :src="firebase_host + '/static/img/cc-2.png'" />
          <img :src="firebase_host + '/static/img/cc-3.png'" />
          <img :src="firebase_host + '/static/img/cc-4.png'" />
        </div>
        <b>Soluzione A)</b> Hai una carta di credito? Puoi cliccare su Paypal e
        poi, invece di effettuare il login Paypal, cliccare su
        <b>Paga con una carta</b>
        <div class="cc d-flex justify-center mt-2">
          <v-icon>link</v-icon>
        </div>

        <b>Soluzione B) </b> Asta Live può essere <b>sbloccata da chiunque</b>.
        Copia il link qui sotto e invialo a un amico/familiare disposto a
        sbloccare la tua asta
      </div>
      <div class="px-5 pb-5">
        <div class="link-to-copy">{{ url }}</div>
      </div>
      <div class="px-5 pb-5 text-center">
        <!-- <v-btn
          depressed
          rounded
          class="orange white--text"
          v-clipboard:copy="urlInvitoComputed"
          v-clipboard:success="onCopySuccess"
        >
          COPIA LINK DI INVITO
        </v-btn> -->
        <v-btn
          depressed
          rounded
          class="orange white--text"
          @click="copyToClipboard"
        >
          COPIA LINK
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import Config from "../../../config-app/config";
import Constants from "../../js/constants";
import * as Helpers from "../../js/helpers";
import mixins from "../../js/mixins";
import Vuex from "vuex";
import db from "../../js/db";
import toast from "../../js/toast";

export default {
  name: "dialog-copy-url-pagamento",
  mixins: [mixins, toast],
  mounted() {
    console.log("--> DialogCopyUrlPagamento mounted.");
    db.on("dialogCopyUrlPagamentoEmitted", this.handleDialogEmitted);
  },
  destroyed() {
    console.log("<-- DialogCopyUrlPagamento destroyed.");
    db.off("dialogCopyUrlPagamentoEmitted", this.handleDialogEmitted);
  },
  props: {
    asta_id_: {
      type: String,
    },
  },
  data() {
    return {
      url: "",
      dialog: false,
      firebase_host: Config.FIREBASE_HOST,
    };
  },
  methods: {
    handleDialogEmitted() {
      this.show();
    },
    show() {
      this.dialog = true;
      this.url = this.getUrlPagamento(this.asta_id_);

      // const resolvedPath = this.$router.resolve({
      //   name: "pagamento",
      //   params: { asta_id: this.asta_id_ },
      // }).href;
      // this.url = window.location.host + "/" + resolvedPath;
    },
    copyToClipboard() {
      const textToCopy = this.url;
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          this.successToast("Link copiato!", "");
        })
        .catch((error) => {
          console.error("Error copying to clipboard:", error);
          this.errorToast(
            "Non è stato possibile copiare il link. Copialo manualmente",
            ""
          );
        });
    },

    dismiss() {
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.link-to-copy {
  border: 1px solid #cfd8dc;
  padding: 5px;
  border-radius: 4px;
}
.cc img {
  width: 30px;
  margin: 5px;
}
</style>
